// Styles
import '../../MapStyles/MapMenu.scss';

// React
import { useEffect, useState } from 'react';

// React Bootstrap
import { Card, Form, InputGroup } from 'react-bootstrap';

// Components
import { Icon, Keywords, Text } from '@components';

// Store
import { useMapStore } from '../../MapStore/UseMapStore';

export function MapEditOverlay({ visible }) {
  const isStatic = useMapStore((state) => state.isStatic);
  const mapKeywords = useMapStore((state) => state.mapKeywords);
  const setMapKeywords = useMapStore((state) => state.setMapKeywords);
  const mapDescription = useMapStore((state) => state.mapDescription);
  const setMapDescription = useMapStore((state) => state.setMapDescription);
  const setAddScale = useMapStore((state) => state.setAddScale);
  const newScaleCreated = useMapStore((state) => state.newScaleCreated);
  const setCreateScale = useMapStore((state) => state.setCreateScale);
  const scaleLength = useMapStore((state) => state.scaleLength);
  const setScaleLength = useMapStore((state) => state.setScaleLength);
  const setSelected = useMapStore((state) => state.setSelected);
  const removeTempObject = useMapStore((state) => state.removeTempObject);
  const setIsDirty = useMapStore((state) => state.setIsDirty);

  const [showSave, setShowSave] = useState<boolean>(false);
  const [length, setLength] = useState<string>('');

  useEffect(() => {
    setScaleLength(length);
  }, [length, setScaleLength]);

  useEffect(() => {
    if (scaleLength) {
      setLength(scaleLength);
    }
  }, [scaleLength]);

  useEffect(() => {
    newScaleCreated !== null ? setShowSave(true) : setShowSave(false);
  }, [newScaleCreated]);

  // Handle submission of item
  function startDraw() {
    setCreateScale(true);
  }

  return (
    <Form className={visible ? 'object-wrapper' : 'object-wrapper-none'}>
      <Card.Body className="object-edit d-flex flex-wrap flex-column align-items-left justify-content-between">
        <div className="d-flex align-items-center justify-content-between">
          <Text className="title-text fw-semibold fs-md">Description:</Text>
          <div>
            <Icon
              name={'add'}
              title="Close"
              className="sonarIcon-rotate-45 align-sub nav-text-icon"
              variant="light"
              showPointer={true}
              disabled={false}
              size="md"
              onClick={() => {
                setSelected('');
                setCreateScale(false);
                removeTempObject();
              }}
            />
          </div>
        </div>
        <Form.Control
          className="mb-3"
          as="textarea"
          value={mapDescription}
          placeholder="Enter map description"
          onChange={(e) => {
            setMapDescription(e.target.value);
            setIsDirty(true);
          }}
        />

        {isStatic && (
          <>
            <div className="d-flex flex-row align-items-center justify-content-between">
              <Text className="title-text fw-semibold fs-md">Scale:</Text>
              {showSave ? (
                <Icon
                  name={'check'}
                  title="Confirm"
                  className="align-sub primary-icon"
                  variant="light"
                  disabled={length === '' ? true : false}
                  size="md"
                  onClick={() => {
                    setAddScale(true);
                    setShowSave(false);
                  }}
                />
              ) : (
                <Icon
                  name={'pin-edit'}
                  title="Draw Scale"
                  className="align-sub primary-icon"
                  variant="light"
                  disabled={newScaleCreated !== null}
                  size="md"
                  onClick={() => {
                    startDraw();
                    setIsDirty(true);
                  }}
                />
              )}
            </div>
            <InputGroup className="mb-3">
              <Form.Control
                aria-label="Scale length"
                type="number"
                step={1}
                min={1}
                placeholder="Length in feet"
                onChange={(e) => {
                  setLength(e.target.value);
                }}
              />
            </InputGroup>
          </>
        )}

        {/* <Text className="fw-semibold fs-md">Overlay Image:</Text>
        <Form.Control className="mb-3" type="file" onChange={(file) => setImage(file)} /> */}

        <Text className="title-text fw-semibold fs-md">Keywords:</Text>
        <div className="keywords-wrap">
          <Keywords
            isAddingKeyword
            initKeywords={mapKeywords}
            onChange={(keywords) => {
              setMapKeywords(keywords);
              setIsDirty(true);
            }}
          />
        </div>
      </Card.Body>
    </Form>
  );
}
